/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Companydetails_Addressku2Inputs */

const ja_company_companydetails_addressku2 = /** @type {(inputs: Company_Companydetails_Addressku2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`品川区`)
};

const en_company_companydetails_addressku2 = /** @type {(inputs: Company_Companydetails_Addressku2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shinagawa-ku`)
};

/**
* | output |
* | --- |
* | "Shinagawa-ku" |
*
* @param {Company_Companydetails_Addressku2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const company_companydetails_addressku2 = /** @type {((inputs?: Company_Companydetails_Addressku2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Companydetails_Addressku2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_company_companydetails_addressku2(inputs)
	return en_company_companydetails_addressku2(inputs)
});
export { company_companydetails_addressku2 as "company_companyDetails_addressKu" }